import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';

export const useIsHeavyAccount = () => useConfigMatch({ [FEATURE_FLAGS.HEAVY_ACCOUNT]: 'true' });
